document.addEventListener("DOMContentLoaded", () => {
		//init animations
		initGranimate();
  });
  
  function initGranimate(){
	// console.log("initGranimate()");
	
	//init ScrollMagic
	var controller = new ScrollMagic.Controller();
  
	//loop thru all .granimated sections
	const granimations = document.querySelectorAll('.granimate-me');
	granimations.forEach(function(granimation){
		
		//find all gran- classes
		granimation.querySelectorAll("[class*='gran-']").forEach(function($element, index){
  
			var delay = ($element.getAttribute("data-gran-delay")!="") ? parseInt($element.getAttribute("data-gran-delay")) : 0;
			var speed = ($element.getAttribute("data-gran-speed")!="") ? $element.getAttribute("data-gran-speed") : ''; //slow, slower, fast, faster
			var scene = new ScrollMagic.Scene({triggerElement: granimation, triggerHook: 'onEnter', offset: 50, reverse: false})
				.addTo(controller)
				.on("enter", function (e) {
					if($element.classList.contains('gran-fadein')){
						granFadeIn($element, delay, speed);
					}
					else if($element.classList.contains('gran-fadeinup')){
						granFadeInUp($element, delay, speed);
					}
					else if($element.classList.contains('gran-sequence')){
						granSequence($element, delay, speed);
					}
					else if($element.classList.contains('gran-slideinup')){
						granSlideInUp($element, delay, speed);
					}
					else if($element.classList.contains('gran-zoomin')){
						granZoomIn($element, delay, speed);
					}
					else if($element.classList.contains('gran-custom')){
						granCustom($element, delay);
					}
				});
		});
	});
  }
  
  function granSpeedClass(speed){
	//todo make this accept an int rather than slow, slower, fast, faster (settings from animate.css)
	return (speed != '' && !undefined) ? 'animate__' + speed : ''; //slow, slower, fast, faster
  }
  
  function granFadeIn($element, delay, speed){
	// console.log('granFadeIn()', $element);
	setTimeout( function(){ $element.classList.add('animate__animated', 'animate__fadeIn', granSpeedClass(speed)); }, delay );
	//granChainNext($element);
  }
  
  function granFadeInUp($element, delay, speed){
	// console.log('granFadeInUp()');
	setTimeout( function(){ 
		$element.classList.add('animate__animated', 'animate__fadeInUp', granSpeedClass(speed));
	}, delay );
	//granChainNext($element);
  }
  
  function granSequence($element, delay, speed){
	// console.log('granSequence()');
	var origSpeed = 500; //default speed
	var selector = ($element.getAttribute("data-gran-selector")!="") ? $element.getAttribute("data-gran-selector") : 'li';
	if (selector == null) selector = 'li';
	// console.log('selector', selector);
	switch(speed){
		case 'slow':
			origSpeed = 1000;
			break;
		case 'slower':
			origSpeed = 1500;
			break;
		case 'fast':
			origSpeed = 350;
			break;
		case 'faster':
			origSpeed = 150;
			break;
	}
	var interval = origSpeed;
	setTimeout( function(){
		$element.querySelectorAll(selector).forEach(function($li){
			setTimeout( function(){ 
								$li.classList.add('animate__animated', 'animate__fadeIn');
							}, interval);
			interval += origSpeed;
		});
  
	}, delay );
	//granChainNext($element);
  }
  
  function granZoomIn($element, delay, speed){
	//console.log('granZoomIn()');
	setTimeout( function(){ $element.classList.add('animate__animated', 'animate__zoomIn', granSpeedClass(speed)); }, delay );
	//granChainNext($element);
  }
  
  function granCustom($element, delay){
	const toEval = $element.getAttribute("data-gran-custom");
	// console.log('granCustom()', toEval, $element);
	setTimeout( function(){
		eval( toEval + "($element)" ); }, delay );//granBlinders($element); or something, more or less
	if (toEval == 'granBlinders') {
		var deviceWidth = window.innerWidth;
		window.addEventListener('resize', function() {
			// granBlinders($element);// this should be debounced or something
			if (deviceWidth != window.innerWidth) {
				window.debounce(granBlinders, 100)($element);
			}
		});
	}
  }
  
  function granChainNext($element, $target, fn){
	//todo eval fn at $target
  }
  
function granDash($element) {
	var selector = ($element.getAttribute("data-gran-selector")!="") ? $element.getAttribute("data-gran-selector") : $element;// TODO: not sure this default will work, hasn't been tested
	var animateMe = $element.querySelector(selector);
	
	animateMe.style.opacity = 1;
	setTimeout(function() {
		var bPaths = animateMe.querySelectorAll('.b');
		bPaths.forEach(function(b) {
			b.style.opacity = 1;
		});
	}, 5000);
	const path = animateMe.querySelector('path');
	path.classList.add('dash');
}

  function granBlinders($element){
	// console.log("granBlinders(" + $element + ")");
  
	$element.querySelectorAll('.blinders').forEach(function($this) {
		//span the lines if not added manually
		if($this.classList.contains("autospan")){
			//add div to do some measuring
			const measureSpan = document.createElement("span");
			measureSpan.classList.add('textMeasure');
			measureSpan.style.whiteSpace = 'nowrap';
			measureSpan.setAttribute('nowrap', 'nowrap');
			measureSpan.textContent = $this.textContent.trim();
			$this.appendChild(measureSpan);
			
			var containerWidth = $this.clientWidth;
			  
			var textArr = $this.querySelector(".textMeasure").textContent.trim().split(" ");
			
			const tempSpan = document.createElement("span");
			tempSpan.classList.add('tempMeasure');
			tempSpan.style.whiteSpace = 'nowrap';
			tempSpan.setAttribute('nowrap', 'nowrap');
			$this.appendChild(tempSpan);
			
			var $tempMeasure = $this.querySelector(".tempMeasure");
			var tempWidth = 0;
			var tempText = "";
			var spans = new Array();
			var currentSpan = 0;
			
			//for each word, add it to the tempMeasure and keep measuring that it'll fit
			for(var i=0; i<textArr.length; i++){
				tempText = tempText + " " + textArr[i];
				$tempMeasure.textContent = tempText;
				if( $tempMeasure.offsetWidth >= containerWidth ){
					tempText = textArr[i]; //start new span
					currentSpan++;
				}
				spans[currentSpan] = tempText;
			}
			
			//for each spans[j], wrap em into <span> and replace $this.html()
			var newHtml = "";
			for(var j=0; j<spans.length; j++){
				newHtml = newHtml + '<span class="stack">' + spans[j].trim() + '</span> ';
			}
			$this.innerHTML = newHtml;
			// Hmmm do we really NEED to do this? We aren't it keeps failing. :(
			// $this.find(".tempMeasure").remove();
			// const tempM = $this.querySelector(".tempMeasure");
			// console.log('tempM', tempM);
			// tempM.parentNode.removeChild(tempM);
		}
		//remove div for measuring
		// not doing it see above, this may or may not matter
		// $this.find(".textMeasure").remove();
		// const textM = $this.querySelector(".textMeasure");
		// textM.parentNode.removeChild(textM);
	});
  
	//handle manual spans
	$element.querySelectorAll(".blinders span").forEach(function($this){
		$this.classList.add('stack');
	});
	
	//prop things open so we can reclaim the space the abspos stuff should have taken
	$element.querySelectorAll(".blinders").forEach(function($this){
		var thisStyle = window.getComputedStyle($this),
			lineHeight = thisStyle.getPropertyValue('line-height'),
			numSpans = 0;

		$this.querySelectorAll(".stack").forEach(function(){
			numSpans++;
		});
		
		//artifical space for how high the H1 should have been
		// let lh = parseInt(lineHeight) + (parseInt(lineHeight) * .1);
		// $this.style.height = (lh*numSpans) + "px";
		$this.style.height = (parseInt(lineHeight)*numSpans) + "px";
	});
	
	//set the blinders visible again
	$element.querySelectorAll(".blinders").forEach(function($this){
		$this.style.visibility = "visible";
	});
  
	//do the blinders animation
	blinderStackSpans($element);
  }
  
  function blinderStackSpans($element){
	// console.log("blinderStackSpans()");
	var blindersOffsetHeight = 0,
		blinderDelay = 0,
		blinderInterval = 250; //millisecond delay between each line reveal
	
	$element.querySelectorAll(".blinders").forEach(function($this){
		var thisStyle = window.getComputedStyle($this),
			lineHeight = thisStyle.getPropertyValue('line-height'),
			numSpans = $this.querySelectorAll("span.stack").length;
		
		blindersOffsetHeight = (parseInt(lineHeight) * numSpans) - parseInt(lineHeight);
		
		$this.querySelectorAll("span.stack").forEach(function(_this){
			//stack the spans:
			_this.style.bottom = blindersOffsetHeight + "px";
			blindersOffsetHeight = blindersOffsetHeight - parseInt(lineHeight);
			//show each row:
			setTimeout( function(){ blinderReveal(_this, lineHeight, blinderDelay); }, blinderDelay );
			blinderDelay += blinderInterval;
		});
		
	});
  }

  function blinderReveal($span, lineHeight, blinderDelay){
	// console.log('lh3', lineHeight);
	// Velocity($span, {height: lineHeight, opacity: 1}, { duration: 250 });
	lineHeight = parseInt(lineHeight) + parseInt(lineHeight)*.1;// we need some more space, line height isn't cutting it anymore, add 10% more
	Velocity($span, {height: lineHeight+'px', opacity: 1}, { duration: 250 });
  }
  
  function animateCount(start, end, $target, speed) {
	if (!speed) speed = 50;
	
	if (start === end) {
		return;
	}

	if (start <= end) {
		$target.querySelector('div').innerHTML = start++;
		if (speed < 100) {
			if (end - start > 100) {
				start += 5;
			} else if(end - start > 75) {
				start += 1;
			}
		}
	} else {
		$target.querySelector('div').innerHTML = start--;
		if (speed < 100) {
			if (start - end > 100) {
				start -= 5;
			} else if(start - end > 75) {
				start -= 1;
			}
		}
	}
	setTimeout(() => {
		animateCount(start, end, $target, speed);
	}, speed);
  }
  
  var numbersAnimated = false;
  function animateNumbers($element) {
	var $percentNum = document.querySelectorAll('.percentage--num');
	if ($percentNum) {
		var delay = 300;
		$percentNum.forEach(function($this) {
			setTimeout(() => {
				const end = parseInt($this.querySelector('div').innerHTML)+1;
				$this.classList.remove('hidden');
				animateCount(0, end, $this, 10);
				numbersAnimated = true;
			}, delay);
			delay += 400;
		});
	}
  }